import React, { useState, useMemo } from 'react';
import { Spinner, Icon } from '@iq/react-components';
import { useSelector } from 'react-redux';

import { getHasPermission } from '../../../../../bundles/auth';
import ListItem from '../../../../ListItem';

const InvitationList = (properties) => {
  const {
    org,
    formData,
    invitations = [],
    searchText = '',
    roleFilter,
    isLoading,
    schema,
    uiSchema,
    onEdit = () => {},
    onUpdate,
    onChange,
    onClose = () => {},
    onDelete,
    getPermissions,
    canEdit = true,
  } = properties;
  const [expanded, setExpanded] = useState([]);
  const canDeleteInvitations = useSelector((state) =>
    getHasPermission(state, 'invitations/Delete', { org })
  );

  const roleFilteredInvites = useMemo(() => {
    if (roleFilter !== 'all') {
      return invitations.filter((u) => (u.roles[roleFilter] || []).length);
    }
    return invitations;
  }, [invitations, roleFilter]);

  const filteredInvites = useMemo(() => {
    if (searchText) {
      const filters = searchText.trim().split(' ');
      return roleFilteredInvites.filter((u) =>
        filters.every((f) => (u.email?.toLowerCase() || '').includes(f.toLowerCase()))
      );
    }
    return roleFilteredInvites;
  }, [roleFilteredInvites, searchText]);

  const headers = ['Email Status', 'Email', 'Site access'];

  const headerCols = headers.map((h, index) => {
    const key = `col-${index}`;
    return (
      <div
        key={key}
        className="list-item--header__col"
      >
        {h}
      </div>
    );
  });

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <Spinner
            size="s"
            className="spinner"
          />
        </div>
      ) : (
        <div className="list-container">
          <ListItem
            isHeader
            columns={headerCols}
          />
          <div className="custom-thin-scrollbar">
            {filteredInvites
              .toSorted((a, b) => a.email.localeCompare(b.email))
              .map((invitation, index) => {
                const item = {
                  ...invitation,
                  ...(invitation.id === formData?.id ? formData : {}),
                };

                const { icon, statusColor } = (() => {
                  if (invitation.status === 'Delivered') {
                    return { icon: 'he-email', statusColor: 'green' };
                  }
                  if (invitation.status === 'Delivery failed') {
                    return { icon: 'he-info', statusColor: 'red' };
                  }
                  return { icon: 'he-time', statusColor: '' };
                })();

                return (
                  <ListItem
                    key={invitation.id}
                    itemIndex={index}
                    entity={`invitation for ${invitation.email}`}
                    withTitle={false}
                    item={item}
                    schema={schema}
                    uiSchema={uiSchema}
                    onDelete={() => onDelete(invitation.id)}
                    disableDelete={!canDeleteInvitations}
                    confirmationDialogTitle={'Delete invitation'}
                    confimationDialogBody={
                      <p style={{ paddingTop: '1.5rem' }}>
                        Are you sure you want to remove <b>{invitation.email}'s</b> invitation?
                      </p>
                    }
                    onEdit={onEdit}
                    disableEdit={!canEdit}
                    onSubmit={(data) => onUpdate(data, invitation.id)}
                    onChange={(data) => onChange(data)}
                    onClose={onClose}
                    onExpand={() => setExpanded(invitation.id)}
                    isExpanded={expanded.includes(invitation.id)}
                    accordionContent={getPermissions(invitation, 'invitation')}
                    columns={[
                      <div
                        key={`row-${index}-emailstatus`}
                        className="ellipsed-text"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <Icon
                          icon={icon}
                          size="s"
                          style={{ color: statusColor }}
                        />
                        <span style={{ marginLeft: 4 }}> {invitation.status || 'Pending'}</span>
                      </div>,
                      <div
                        key={`row-${index}-email`}
                        className="ellipsed-text"
                      >
                        {invitation.email}
                      </div>,
                      <div
                        key={`row-${index}-count`}
                        className="count-indicator"
                      >
                        {Object.values(invitation?.roles || {}).reduce(
                          (acc, siteIds) => acc + siteIds.length,
                          0
                        )}
                      </div>,
                    ]}
                  />
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};

export default InvitationList;
